var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolanaLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "white",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7481 62.1062C30.1101 61.74 30.608 61.5263 31.1359 61.5263H79.0164C79.8914 61.5263 80.3288 62.5946 79.7103 63.2202L70.2519 72.7885C69.8899 73.1548 69.3921 73.3684 68.8641 73.3684H20.9836C20.1086 73.3684 19.6712 72.3002 20.2897 71.6745L29.7481 62.1062Z",
    fill: "#2BCDE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7481 26.5799C30.1252 26.2136 30.623 26 31.1359 26H79.0164C79.8914 26 80.3288 27.0682 79.7103 27.6939L70.2519 37.2622C69.8899 37.6285 69.3921 37.8421 68.8641 37.8421H20.9836C20.1086 37.8421 19.6712 36.7739 20.2897 36.1482L29.7481 26.5799Z",
    fill: "#2BCDE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2519 43.9483C69.8899 43.5821 69.3921 43.3684 68.8641 43.3684H20.9836C20.1086 43.3684 19.6712 44.4367 20.2897 45.0623L29.7481 54.6306C30.1101 54.9969 30.608 55.2105 31.1359 55.2105H79.0164C79.8914 55.2105 80.3288 54.1423 79.7103 53.5166L70.2519 43.9483Z",
    fill: "#1868B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaLight);
export default __webpack_public_path__ + "static/media/solana-light.e0e4d45a60ebeef60ab9b12ff5daa3d8.svg";
export { ForwardRef as ReactComponent };